module.exports = __webpack_public_path__ + "static/media/help.baa2d204.png";